import React, { useState } from 'react';

function App() {
  const [activeTab, setActiveTab] = useState('defunciones');

  const reports = {
    defunciones: {
      title: "Defunciones",
      description: "Sistema Informático Nacional de Defunciones - Perú",
      longDescription: "El Tablero de Control de Defunciones de Perú representa una herramienta de visualización de datos moderna y dinámica, diseñada específicamente para el monitoreo y análisis de estadísticas vitales relacionadas con la mortalidad en el país. Este dashboard integra múltiples elementos visuales interactivos como gráficos de barras, líneas temporales, diagramas circulares y tablas de datos, que permiten una comprensión rápida y efectiva de las tendencias y patrones de mortalidad. Su diseño intuitivo facilita el acceso a información crucial para funcionarios de salud pública, investigadores y tomadores de decisiones, permitiendo filtrar y analizar datos por diferentes dimensiones como ubicación geográfica, grupos de edad y causas de fallecimiento.",
      embedUrl: "https://app.powerbi.com/view?r=eyJrIjoiN2VjZjY3M2QtNTcyOS00NmUwLTg0Y2YtYjYzM2IzN2FkZTE3IiwidCI6IjUxMTJjNjE4LWM4M2ItNGQ5ZC1iMjBhLTM0MjAzYjkzMmNmNCJ9"
    },
    /* Ejemplo de cómo agregar otro reporte
    nacimientos: {
      title: "Nacimientos",
      description: "Sistema Informático de Nacimientos - Perú",
      longDescription: "El Tablero de Control de Nacimientos proporciona una visión integral de las estadísticas de natalidad en Perú...",
      embedUrl: "URL_DEL_DASHBOARD"
    },
    */
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header Principal */}
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <h1 className="text-3xl font-bold text-gray-900">
            Dashboard Analítico
          </h1>
          <p className="mt-2 text-gray-600">
            Sistema de Reportes Integrados
          </p>
        </div>
      </header>

      {/* Contenido Principal */}
      <main className="max-w-7xl mx-auto px-4">
        {/* Tabs Navigation */}
        <div className="mt-6 mb-4 border-b border-gray-200">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {Object.entries(reports).map(([key, report]) => (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`
                  py-4 px-1 border-b-2 font-medium text-sm
                  ${activeTab === key
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }
                `}
              >
                {report.title}
              </button>
            ))}
          </nav>
        </div>

        {/* Descripción dinámica del dashboard */}
        <div className="bg-white shadow rounded-lg p-6 mb-4">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">
            Acerca de {reports[activeTab].title}
          </h2>
          <p className="text-gray-600 leading-relaxed">
            {reports[activeTab].longDescription}
          </p>
        </div>

        {/* Tab Content */}
        <div className="bg-white shadow rounded-lg overflow-hidden">
          {/* Toolbar */}
          <div className="px-4 py-3 border-b border-gray-200 flex justify-between items-center bg-gray-50">
            <div>
              <h2 className="text-lg font-medium text-gray-900">
                {reports[activeTab].title}
              </h2>
              <p className="text-sm text-gray-500">
                {reports[activeTab].description}
              </p>
            </div>
            <button 
              onClick={() => {
                const iframe = document.querySelector(`iframe[data-tab="${activeTab}"]`);
                if (iframe) {
                  iframe.requestFullscreen?.();
                }
              }}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors flex items-center gap-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M3 4a1 1 0 011-1h4a1 1 0 010 2H6.414l2.293 2.293a1 1 0 11-1.414 1.414L5 6.414V8a1 1 0 01-2 0V4zm13 0a1 1 0 011 1v4a1 1 0 01-2 0V6.414l-2.293 2.293a1 1 0 11-1.414-1.414L13.586 5H12a1 1 0 110-2h4zm-13 13a1 1 0 01-1-1v-4a1 1 0 112 0v1.586l2.293-2.293a1 1 0 111.414 1.414L5.414 15H7a1 1 0 110 2H3zm13 0a1 1 0 01-1-1v-4a1 1 0 112 0v1.586l2.293-2.293a1 1 0 111.414 1.414L17.414 15H19a1 1 0 110 2h-4z" clipRule="evenodd" />
              </svg>
              Pantalla Completa
            </button>
          </div>
          
          {/* PowerBI iframes */}
          {Object.entries(reports).map(([key, report]) => (
            <div 
              key={key}
              className={`w-full ${activeTab === key ? 'block' : 'hidden'}`}
            >
              <iframe 
                data-tab={key}
                title={report.title}
                width="100%"
                height="1060"
                src={report.embedUrl}
                frameBorder="0" 
                allowFullScreen={true}
              />
            </div>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="max-w-7xl mx-auto px-4 py-6">
        <div className="border-t border-gray-200 pt-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="font-bold mb-2 text-gray-900">Actualización</h3>
              <p className="text-gray-600">Datos actualizados una vez a la semana</p>
            </div>
            <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="font-bold mb-2 text-gray-900">Soporte</h3>
              <p className="text-gray-600">Contacto: oscar.salas@dataplus.com.pe</p>
            </div>
            <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="font-bold mb-2 text-gray-900">Acceso</h3>
              <p className="text-gray-600">Información de acceso público</p>
            </div>
          </div>
          <p className="text-center text-gray-600">
            © 2024 Dashboard Analítico. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;